import qs from 'qs';
import { getConfig } from '@/config.ts';
import useWebSockets from '@/composables/useWebSockets';
import { instance } from '@/api/api.ts';
import { del, set } from '@/utils/reactive-object.ts';

function getAclRoleAccessChannels(role) {
    return {
        [`acl-access-create-${role}`]: 'SET_ACCESS',
        [`acl-access-update-${role}`]: 'SET_ACCESS',
        [`acl-access-remove-${role}`]: 'REMOVE_ACCESS',
    };
}

function getAclUserAccessChannels(userId) {
    return {
        [`acl-user-access-create-${userId}`]: 'SET_ACCESS',
        [`acl-user-access-update-${userId}`]: 'SET_ACCESS',
        [`acl-user-access-remove-${userId}`]: 'REMOVE_ACCESS',
    };
}

const {
    on: onWebSocket,
    off: offWebSocket,
} = useWebSockets();

export default {
    namespaced: true,
    state: {
        accesses: {},
    },
    getters: {
        isExists(state) {
            return Object.keys(state.accesses).length;
        },
        isAccessExists(state) {
            return access => !!state.accesses[access];
        },
        isGranted(state) {
            return access => (Array.isArray(access) ? access : [access]).every(item => ['all', 'my'].includes(state.accesses[item]));
        },
    },
    mutations: {
        SET_ACCESSES(state, accesses) {
            set(state, 'accesses', accesses);

            // TODO backward compatibility with
            //  * public/js/manager/scripts.js:749
            //  * src/assets/util/manager/scripts.js:2094
            set(getConfig(), 'aclAccess', accesses);
        },
        SET_ACCESS(state, data) {
            set(state.accesses, data.access, data.value);

            // TODO backward compatibility with
            //  * public/js/manager/scripts.js:749
            //  * src/assets/util/manager/scripts.js:2094
            set(getConfig().aclAccess, data.access, data.value);
        },
        REMOVE_ACCESS(state, data) {
            del(state.accesses, data.access);

            // TODO backward compatibility with
            //  * public/js/manager/scripts.js:749
            //  * src/assets/util/manager/scripts.js:2094
            del(getConfig().aclAccess, data.access);
        },
    },
    actions: {
        async GET_ACCESSES({ commit, dispatch }) {
            commit('SET_ACCESSES', await dispatch(
                'REQUEST',
                {
                    action: 'acl/available-access-list',
                },
            ));
        },
        SET_ACCESSES({ commit }, data) {
            commit('SET_ACCESSES', data);
        },
        SUBSCRIBE_ROLE_ACCESS({ commit }, role) {
            Object.entries(getAclRoleAccessChannels(role)).forEach(([channel, mutation]) => {
                onWebSocket(channel, (message) => {
                    const data = JSON.parse(message);

                    commit(mutation, data);
                });
            });
        },
        UNSUBSCRIBE_ROLE_ACCESS(context, role) {
            Object.keys(getAclRoleAccessChannels(role)).forEach(channel => offWebSocket(channel));
        },
        SUBSCRIBE_USER_ACCESS({ commit }, userId) {
            Object.entries(getAclUserAccessChannels(userId)).forEach(([channel, mutation]) => {
                onWebSocket(channel, (message) => {
                    const data = JSON.parse(message);

                    commit(mutation, data);
                });
            });
        },
        UNSUBSCRIBE_USER_ACCESS(context, userId) {
            Object.keys(getAclUserAccessChannels(userId)).forEach(channel => offWebSocket(channel));
        },
        REQUEST(context, { action, data }) {
            return instance.post(
                `/${action}`,
                qs.stringify(data),
            );
        },
    },
};
